import z from "zod";
import { ServiceOrderWorkflowActionIdScheme } from "./ids";
import { ServiceOrderStatus } from "./enums/ServiceOrderStatus";
import { ServiceOrderPrintMode } from "./enums/ServiceOrderPrintMode";
import { ServiceOrderWorkflowTrigger } from "./enums/ServiceOrderWorkflowTrigger";
import { ServiceOrderWorkflowActionType } from "./enums/ServiceOrderWorkflowActionType";
import { ServiceOrderDocumentType } from "./enums/ServiceOrderDocumentType";

const ServiceOrderWorkflowActionBaseScheme = z.object({
  id: ServiceOrderWorkflowActionIdScheme,
  enabled: z.boolean(),
});

const ServiceOrderWorkflowPrintCustomerCopyActionScheme =
  ServiceOrderWorkflowActionBaseScheme.extend({
    type: z.literal(ServiceOrderWorkflowActionType.PRINT_CUSTOMER_COPY),
    mode: z.enum(ServiceOrderPrintMode),
  });

const ServiceOrderWorkflowPrintWorkOrderActionScheme =
  ServiceOrderWorkflowActionBaseScheme.extend({
    type: z.literal(ServiceOrderWorkflowActionType.PRINT_WORK_ORDER),
    mode: z.enum(ServiceOrderPrintMode),
  });

const ServiceOrderWorkflowEmailActionScheme =
  ServiceOrderWorkflowActionBaseScheme.extend({
    type: z.literal(ServiceOrderWorkflowActionType.EMAIL),
    subject: z.string(),
    template: z.string(),
  });

const ServiceOrderWorkflowSmsActionScheme =
  ServiceOrderWorkflowActionBaseScheme.extend({
    type: z.literal(ServiceOrderWorkflowActionType.SMS),
    template: z.string(),
  });

export const ServiceOrderWorkflowActionScheme = z.discriminatedUnion("type", [
  ServiceOrderWorkflowPrintCustomerCopyActionScheme,
  ServiceOrderWorkflowPrintWorkOrderActionScheme,
  ServiceOrderWorkflowEmailActionScheme,
  ServiceOrderWorkflowSmsActionScheme,
]);

export const ServiceOrderWorkflowStepScheme = z.object({
  trigger: z.enum(ServiceOrderWorkflowTrigger),
  status: z.enum(ServiceOrderStatus).nullable().optional(),
  enabled: z.boolean(),
  actions: z.array(ServiceOrderWorkflowActionScheme),
});

export const ServiceOrderWorkflowPrintScheme = z.object({
  document: z.enum(ServiceOrderDocumentType),
  mode: z.enum(ServiceOrderPrintMode),
});

export type ServiceOrderWorkflowAction = z.infer<
  typeof ServiceOrderWorkflowActionScheme
>;
export type ServiceOrderWorkflowStep = z.infer<
  typeof ServiceOrderWorkflowStepScheme
>;
export type ServiceOrderWorkflowPrint = z.infer<
  typeof ServiceOrderWorkflowPrintScheme
>;
